module.exports = __webpack_public_path__ + "static/media/gMask-tablet.dd0bc14c.png";